import { render, staticRenderFns } from "./bank-truewallet-account-form.vue?vue&type=template&id=1f5974ef&"
import script from "./bank-truewallet-account-form.vue?vue&type=script&lang=js&"
export * from "./bank-truewallet-account-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports